var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.894 3.106c3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0A1 1 0 0 1 4.52 15.48a7.75 7.75 0 1 0 0-10.96 1 1 0 0 1-1.414-1.414 9.745 9.745 0 0 1 13.789 0z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 10V6.875M10 10l3.906 3.907"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.565 6.967 2.084 2.5.023.029a.827.827 0 0 1 .034.048l-.057-.077a.838.838 0 0 1 .149.8 1.001 1.001 0 0 1-.063.14.877.877 0 0 1-.086.127l-2.084 2.5a.833.833 0 1 1-1.28-1.067l.944-1.135-3.139.007a.833.833 0 1 1-.005-1.667l3.142-.007-.942-1.131a.833.833 0 1 1 1.28-1.067z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRequest);
export default __webpack_public_path__ + "static/media/clock-request.da00d06fefb7ad656394674da68798e0.svg";
export { ForwardRef as ReactComponent };